export const SUPPORTED_CHARTS = ['channels-temporal', 'channels-depth']
